import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";

export const StyledCard = styled(FlexDiv)`
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0px 16px 24px
      rgba(${({ theme }) => theme.colors.shadows.black}, 0.06),
    0px 2px 6px rgba(${({ theme }) => theme.colors.shadows.black}, 0.04),
    0px 0px 1px rgba(${({ theme }) => theme.colors.shadows.black}, 0.04);
  width: 100%;
  margin: 0px 8px 32px;
  background-color: ${({ theme }) => theme.colors.white};
  ${({ grayedOut }) => grayedOut && `filter: grayScale(1);`};
  @media only screen and (max-width: 767px) {
    margin: 0 16px 16px;
  }
`;
